module.exports = __webpack_public_path__ + "static/media/ma.fe7b5f83.svg";